import dynamicfunction from '../../../../utils/dynamicfunction';
import { cn } from '../../../../utils/utils';
import { fontSizes } from '../../../../constants/constants';

const Text = ({
  text = '',
  weight,
  size,
  color = 'text-black',
  className,
  isRequired = false,
  onClick,
  isCenter,
  style,
  isDisabled = false,
  isTruncate = true,
  align,
  dir,
}) => {
  const { TextWeight, TextAlign, isArabic } = dynamicfunction();

  return (
    <span
      style={{
        fontSize: size ?? fontSizes.h16,
      }}
      className={cn(
        isDisabled ? 'text-text-grey' : color,
        isTruncate && 'truncate',
        weight ? weight : TextWeight.regular,
        isCenter ? 'text-center' : align ? align : TextAlign,
        className
      )}
      onClick={isDisabled ? undefined : () => onClick?.()}
      dir={dir ? dir : isArabic ? 'rtl' : 'ltr'}
    >
      {text}
      {isRequired && <span className='text-red-500'>*</span>}
    </span>
  );
};

export default Text;
